import * as React from "react"
import { ChurnData } from "./charts/Churn"
import { FilterContextType } from "components/context/filter"
import { BPMAnalyticsAPI } from "api"
import { Statisic } from "components/Statistic"
import { DOWNLOAD } from "assets"
import { ScrollView } from "components/ScrollView"

interface StatisticState {
    totalSubs: number
    renewals: number
    cancellations: number
    newSubs: number
}

export const Financial: React.FC = () => {
    const filterContext = React.useContext(FilterContextType)
    const [statistics, setStatistics] = React.useState<StatisticState>()

    React.useEffect(() => {
        filterContext.setFinancialMode(true)
        return () => {
            filterContext.setFinancialMode(false)
        }
    }, [])

    React.useEffect(() => {
        setStatistics(undefined)
        BPMAnalyticsAPI.getv2<StatisticState>('financial-statistics', filterContext).then((stats) => {
            setStatistics(stats)
        })
    }, [filterContext])


    return <div className='dashboard'>
        <div className='statistics'>
            <ScrollView>
                <Statisic title={`Total Orders Created`} icon={DOWNLOAD} value={statistics?.totalSubs} />
                <Statisic title={`Users Renewed`} icon={DOWNLOAD} value={statistics?.renewals} />
                <Statisic title={`Users Cancelled`} icon={DOWNLOAD} value={statistics?.cancellations} />
                <Statisic title={`New Subscriptions`} icon={DOWNLOAD} value={statistics?.newSubs} />
            </ScrollView>
        </div>
        <div className='charts'>
            <div className='bpm-container'>
                <div className='row'>
                    <div className='col'>
                        <ChurnData />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/pages/Financial/index.tsx